import React from 'react'
import { ICheckbox } from './interface'
import './styles.scss'

const Checkbox = ({ checked = false, handleChange, linkText, linkUrl, text }: ICheckbox): JSX.Element => {
  return (
    <div className='checkbox-container'>
      <label className='checkbox-container__label'>
        {text}{' '}
        <a href={linkUrl} target='_blank' rel='noreferrer'>
          {linkText}
        </a>
        <input checked={checked} type='checkbox' onChange={handleChange} />
        <span className='checkbox-container__checkmark'></span>
      </label>
    </div>
  )
}

export default Checkbox
